module.exports = __webpack_public_path__ + "static/img/video_icon2_1.1bbde93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon2_1.png
// module id = M5zk
// module chunks = 0